<template>
  <div class="container print-receipt">
    <ErrorsMessages :errors="errors" />
    <div v-if="data.id">
      <table v-for="table in tables" :key="table.text" class="table">
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <div class="row">
                  <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                    <img
                      v-if="rest_home_logo_url"
                      class="rest_home_logo_url"
                      :src="rest_home_logo_url"
                    />
                    <div v-if="!rest_home_logo_url" class="ml-1">
                      <strong class="text-uppercase">{{
                        rest_home_name
                      }}</strong>
                    </div>
                  </div>
                  <div
                    class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex align-items-center"
                  >
                    <div class="ml-5">
                      <h3 class="mb-0">Recibo</h3>
                      <h4 class="mb-0 worksansr upper-text">
                        R$ {{ formatMoney(String(data.value)) }}
                      </h4>
                      <h6 class="mb-0 worksansr upper-text">
                        {{ table.text }}
                      </h6>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                  >
                    <img class="logo" :src="logo" width="180" />
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="content">
                <div class="row">
                  <div class="col-md-6">
                    <h2>Recibo</h2>
                  </div>
                  <div class="col-md-6 text-right">
                    <h2>R$ {{ formatMoney(String(data.value)) }}</h2>
                  </div>
                </div>
                <div
                  class="page-break-inside"
                  v-for="(item, key) in data.items"
                  :key="key"
                >
                  <p class="worksansr m-0">
                    Recebi de
                    <b>
                      {{
                        item.spent_or_gain == "CREDITO"
                          ? item.finance_client_name
                            ? item.finance_client_name
                            : "[CLIENTE NÃO INFORMADO]"
                          : item.provider_company_name
                          ? item.provider_company_name
                          : "[FORNECEDOR NÃO INFORMADO]"
                      }}</b
                    >, a importância de R$
                    {{ formatMoney(String(item.value)) }} (<b>{{
                      handleTextValue(item)
                    }}</b
                    >), referente o(a): <b> {{ item.description }}</b
                    >.
                  </p>
                  <p class="worksansr m-0">
                    Dou plena e geral quitação dos débitos aos quais este recibo
                    se refere.
                  </p>
                  <p class="worksansr text-right">
                    {{
                      user.rest_home_uf && user.rest_home_uf.name
                        ? user.rest_home_uf.name
                        : ""
                    }}
                    -
                    {{
                      user.rest_home_uf && user.rest_home_uf.initials
                        ? user.rest_home_uf.initials
                        : ""
                    }}, ____/____/______
                  </p>
                  <p class="worksansr text-right mt-3 mb-0 text-uppercase">
                    ___________________________________________
                    <br />
                    {{
                      item.spent_or_gain == "CREDITO"
                        ? user.rest_home_name
                        : item.provider_company_name
                        ? item.provider_company_name
                        : "[FORNECEDOR NÃO INFORMADO]"
                    }}
                  </p>
                  <p
                    class="worksansr m-0 text-right"
                    v-if="item.spent_or_gain == 'DEBITO'"
                  >
                    {{ item.provider_cpf_cnpj }}
                  </p>
                  <hr />
                </div>
                <div class="row page-break-inside">
                  <div class="col-md-6 pt-0 pb-0">
                    <p class="m-0 worksansr">
                      {{ user.rest_home_fantasy_name }}
                    </p>
                    <p class="m-0 worksansr">{{ user.rest_home_cnpj }}</p>
                  </div>
                  <div class="col-md-6 pt-0 pb-0 text-right">
                    <p class="m-0 worksansr">
                      Telefone: {{ user.rest_home_first_phone }}
                    </p>
                    <p class="m-0 worksansr">
                      {{ user.rest_home_address }},
                      {{ user.rest_home_num_address }} -
                      {{ user.rest_home_neighborhood }} -
                      {{
                        user.rest_home_uf && user.rest_home_uf.name
                          ? user.rest_home_uf.name
                          : ""
                      }}
                    </p>
                  </div>
                </div>
                <div class="mt-2">
                  {{ table.text }}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pl-0 pt-0 col-md-12 text-right">
        <v-btn @click="handlePrint" class="v-warning">IMPRIMIR</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../../Components/ErrorsMessages";

import api from "../../../../../../services/api";

import routes from "../../../../../../routes";

import { formatDate, formatMoney } from "../../../../../../lib/format";

import { userData } from "../../../../../../lib/functions";

import extenso from "extenso";

export default {
  name: "ReceiptPrint",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      tables: [{ text: "1ª Via - Pagante" }, { text: "2ª Via - Recebente" }],
      id: "",
      data: {},
      user: {},
      items: [],
      errors: [],
      rest_home_name: null,
      rest_home_logo_url: null,
      logo: null,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    formatMoney,
    handleTextValue(item) {
      let { value } = item;

      value = String(value);

      value = formatMoney(value);

      value = String(value).replace(".", "").replace(".", "");

      return extenso(value, {
        number: { decimalSeparator: "comma" },
        mode: "currency",
        currency: { type: "BRL" },
      });
    },
    async retrieve() {
      const { id } = routes.history.current.params;

      if (!id) {
        this.errors = [{ message: "Dados não encontrado" }];
        return;
      }

      this.id = id;

      const { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      await this.get();
    },
    async get() {
      try {
        this.loading = true;

        let { id } = this;

        let params = { id };

        const response = await api.get("/rest-home/financial/launch/receipt", {
          params,
        });

        const { error, errors, data } = response.data;

        if (!error) {
          this.data = data;
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePrint() {
      window.print();
    },
  },
};
</script>

<style>
@page {
  size: 0;
}

.print-receipt .header,
.print-receipt .header-space {
  height: 100px;
}

.print-receipt .header {
  position: fixed;
  top: 0;
}

.print-receipt .logo {
  height: 50px;
  object-fit: contain;
}

.print-receipt .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.print-receipt table,
.print-receipt td,
.print-receipt th,
.print-receipt tfoot {
  width: 100% !important;
  padding: 5px;
  cursor: auto !important;
}

.print-receipt th {
  background-color: #f5f5f5;
}

@media print {
  .print-receipt table {
    width: 100% !important;
    border: none !important;
    margin-top: 10px !important;
  }

  .print-receipt .table {
    page-break-before: always !important;
  }

  .print-receipt .page-break-inside {
    page-break-inside: avoid !important;
  }

  * {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4em !important;
  }

  .print-receipt button {
    display: none;
  }
}
</style>
